import { render, staticRenderFns } from "./CurrentYear.vue?vue&type=template&id=fbfc5a32&"
import script from "./CurrentYear.vue?vue&type=script&lang=js&"
export * from "./CurrentYear.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fbfc5a32')) {
      api.createRecord('fbfc5a32', component.options)
    } else {
      api.reload('fbfc5a32', component.options)
    }
    module.hot.accept("./CurrentYear.vue?vue&type=template&id=fbfc5a32&", function () {
      api.rerender('fbfc5a32', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2X3Wasxb6sL52/JS/comp/CurrentYear.vue"
export default component.exports